import { Injectable } from '@angular/core';
import { AvailableIntegrations } from '@/core/models/IntegrationEntity';

/**
 * Service to temporarily store data.
 * Can be used to transmit data between components without persisting it.
 */
@Injectable({
    providedIn: 'root',
})
export class TempStoreService {
    private store = new Map<string, unknown>();

    public set<T>(key: string, value: T): void {
        this.store.set(key, value);
    }

    public get<T>(key: string): T | undefined {
        return this.store.get(key) as T | undefined;
    }

    /**
     * Gets the value for the given key and clears it from the store.
     * Typical one time transport use case.
     */
    public getAndClear<T>(key: string): T | undefined {
        const val = this.store.get(key) as T | undefined;
        if (val !== undefined) {
            this.store.delete(key);
        }
        return val;
    }

    public has(key: string): boolean {
        return this.store.has(key);
    }

    public delete(key: string): void {
        this.store.delete(key);
    }

    public clear(): void {
        this.store.clear();
    }
}

// helper for key values:
export function getMissingUnitsKey(serviceIdentifier: AvailableIntegrations): string {
    return 'missingUnits:' + serviceIdentifier;
}
